import { __exportAll } from "../../_virtual/_rolldown/runtime.js";

//#region src/types/plugins/ConsumeSharedPlugin.ts
var ConsumeSharedPlugin_exports = /* @__PURE__ */ __exportAll({});

//#endregion
export { ConsumeSharedPlugin_exports };
//# sourceMappingURL=ConsumeSharedPlugin.js.map